import { useLang } from "@/i18n";
import Reveal, { SectionHead } from "./Reveal";

export default function Process() {
  const { t } = useLang();
  return (
    <section id="process" className="relative border-t border-white/5 bg-[#050a16]/50 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <SectionHead
          badge={t.process.badge}
          title={t.process.title}
          testId="process-title"
        />
        <div className="relative mt-16 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div className="pointer-events-none absolute top-8 left-0 right-0 hidden md:block border-t border-dashed border-cyan-400/20" />
          {t.process.steps.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.15}>
              <div data-testid={`process-step-${i + 1}`} className="relative">
                <div className="relative z-10 flex h-16 w-16 items-center justify-center rounded-2xl border border-cyan-400/40 bg-[#030712] shadow-[0_0_28px_rgba(0,240,255,0.18)]">
                  <span className="font-mono-accent text-xl font-semibold text-vortex-gradient">{step.num}</span>
                </div>
                <h3 className="font-display mt-6 text-xl sm:text-2xl font-semibold tracking-tight">{step.title}</h3>
                <p className="mt-3 max-w-sm text-sm sm:text-base text-slate-400 leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
